/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Marketing_Faq_License_DetailInputs */

const en_marketing_faq_license_detail = /** @type {(inputs: Marketing_Faq_License_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`One purchase covers one product. The full terms come with the purchase; if you are unsure whether your use fits, ask ${i?.email}.`)
};

const es_marketing_faq_license_detail = /** @type {(inputs: Marketing_Faq_License_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Una compra cubre un producto. Los términos completos llegan con la compra; si no tienes claro si tu caso encaja, escribe a ${i?.email}.`)
};

const fr_marketing_faq_license_detail = /** @type {(inputs: Marketing_Faq_License_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un achat couvre un produit. Les conditions complètes accompagnent l'achat ; si vous ne savez pas si votre usage entre dans le cadre, écrivez à ${i?.email}.`)
};

/**
* | output |
* | --- |
* | "One purchase covers one product. The full terms come with the purchase; if you are unsure whether your use fits, ask {email}." |
*
* @param {Marketing_Faq_License_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_faq_license_detail = /** @type {((inputs: Marketing_Faq_License_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Faq_License_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_faq_license_detail(inputs)
	if (locale === "es") return es_marketing_faq_license_detail(inputs)
	return fr_marketing_faq_license_detail(inputs)
});